import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import L from "leaflet";
import { groupBySchool } from "@/lib/leaderboard";
import { TEXAS_CENTER, TEXAS_DEFAULT_ZOOM } from "@/lib/texasSchools";
import type { LeaderboardRow } from "@/types/database";

// Fix default Leaflet marker icon paths in Vite bundling.
const defaultIcon = L.icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

interface Props { rows: LeaderboardRow[]; }

export default function TexasLeaderboardMap({ rows }: Props) {
  const markers = groupBySchool(rows);
  return (
    <div className="rounded-2xl overflow-hidden border border-steel-700 shadow-xl">
      <MapContainer
        center={TEXAS_CENTER}
        zoom={TEXAS_DEFAULT_ZOOM}
        style={{ height: 420, width: "100%" }}
        scrollWheelZoom
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {markers.map((m) => (
          <Marker key={m.school_id} position={[m.latitude, m.longitude]} icon={defaultIcon}>
            <Popup>
              <div className="text-sm">
                <div className="font-semibold">{m.school_name}</div>
                {m.city && <div className="text-steel-300">{m.city}</div>}
                <ol className="mt-2 space-y-1 list-decimal pl-4">
                  {m.students.slice(0, 5).map((s) => (
                    <li key={s.student_id}>
                      <span className="font-medium">{s.full_name}</span>
                      <span className="text-steel-400"> · #{s.rank} · {s.best_score} pts</span>
                    </li>
                  ))}
                </ol>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
